export const API_URL = process.env.REACT_APP_API_URL || 'https://ikea-products-api-prod.test.qollap.com';

export const APP_LOADERS = Object.freeze({
	appInit: 'appInit',
});
